<template>
	<v-form v-model="valid" ref="form">
		<v-tabs-items v-model="tab">
			<v-tab-item value="tabGeral">
				<v-row>
					<v-col class="pt-0 pb-0" cols="12" md="2" sm="4">
						<v-text-field
							v-model="anoExercicio"
							:rules="[$rules.required(), $rules.between(intervaloAno)]"
							label="Ano Exercício"
							required
							type="number"
							disabled
						/>
					</v-col>
					<v-col class="pt-0 pb-0" cols="12" md="1" sm="4">
						<v-text-field
							v-model="numeroEmenda"
							:rules="[
								$rules.required(),
								(v) => (v < 0 ? 'Valor deve ser maior que zero.' : true),
							]"
							label="Número"
							required
							type="number"
							:disabled="readOnly"
							autofocus
						/>
					</v-col>
					<v-col class="pt-0 pb-0" cols="12" md="2" sm="4">
						<v-select
							v-model="esfera"
							:rules="[$rules.required()]"
							:items="esferaItems"
							label="Esfera"
							item-text="descricao"
							item-value="id"
							required
							:disabled="readOnly"
							return-object
						/>
					</v-col>
					<v-col class="pt-0 pb-0" cols="12" md="4" sm="7">
						<v-select
							v-model="parlamentarExercicio"
							:rules="[$rules.required()]"
							:items="parlamentarItems"
							label="Parlamentar"
							item-text="parlamentar.nome"
							item-value="id"
							:no-data-text="parlamentarNaoCarregado"
							required
							return-object
							:disabled="readOnly"
						/>
					</v-col>
					<v-col class="pt-0 pb-0" cols="12" md="3" sm="5">
						<!-- :rules="[$rules.required()]"	-->
						<v-select
							class="no-button"
							v-model="emendaSituacao"
							:items="situacaoItems"
							label="Situação da Emenda"
							item-text="descricao"
							item-value="id"
							required
							return-object
							:disabled="true"
						/>
					</v-col>

					<v-col class="pt-0 pb-0" cols="12" md="9">
						<v-text-field
							v-model="descricao"
							:rules="[$rules.required()]"
							label="Descrição"
							required
							:disabled="readOnly"
						/>
					</v-col>

					<v-col class="pt-0 pb-0" cols="12" md="3">
						<vuetify-money
							v-model="valor"
							label="Valor da Emenda"
							:options="{
								locale: 'pt-BR',
								prefix: 'R$',
								suffix: '',
								length: 11,
								precision: 2,
							}"
							:rules="[
								$rules.required(),
								(v) => (v > '0,00' ? true : 'Valor deve ser maior que zero.'),
							]"
							:properties="{
								rules: [$rules.required()],
								required: true,
							}"
							:disabled="readOnly"
						/>
					</v-col>

					<v-col class="pt-0 pb-0" cols="12" md="12">
						<v-textarea
							v-model="justificativa"
							label="Justificativa"
							rows="1"
							auto-grow
							:disabled="readOnly"
						/>
					</v-col>

					<v-col class="pt-0 pb-0" cols="12" md="6" sm="6">
						<v-select
							v-model="secretaria"
							:rules="[$rules.required()]"
							:items="secretariaItems"
							label="Secretaria destino"
							item-text="nome"
							item-value="id"
							required
							return-object
							:disabled="readOnly"
						>
						</v-select>
					</v-col>
					<v-col class="pt-0 pb-0" cols="12" md="6" sm="6">
						<v-text-field
							v-model="instituicao"
							label="Instituição"
							:disabled="readOnly"
						/>
					</v-col>

					<v-col class="pt-0 pb-0" cols="12" md="6" sm="6">
						<v-text-field
							v-model="linkPlanoTrabalho"
							label="Plano de trabalho"
							:disabled="readOnly"
						/>
					</v-col>

					<v-col class="pt-0 pb-0" cols="12" md="6" sm="6">
						<v-text-field
							v-model="linkRelatorioGestao"
							label="Relatório de gestão"
							:disabled="readOnly"
						/>
					</v-col>

					<v-col class="pt-0 pb-0" cols="12" md="12">
						<v-textarea
							v-model="observacao"
							label="Observações"
							rows="4"
							maxlength="500"
							counter
							required
							:disabled="readOnly"
							auto-grow
						></v-textarea>
					</v-col>

					<!-- <v-col class="pt-0 pb-0" cols="12" md="12">
						<v-textarea
							v-model="respostaCamara"
							label="Resposta da Câmara"
							rows="8"
							maxlength="8000"
							counter
							required
							:disabled="readOnly"
							auto-grow
						></v-textarea>
					</v-col> -->
				</v-row>

				<v-card-title> Despachos </v-card-title>
				<v-tramitacao-list v-model="tramitacoesEmenda" :read-only="readOnly" />
			</v-tab-item>

			<v-tab-item value="tabDotacoes">
				<!-- <v-form ref="formDotacao" @keyup.native.enter="incluirDotacao">
					<v-row>

						<v-col md="4">
							<v-btn primary @click="exibirPesquisaDotacao" :disabled="readOnly">
								<v-icon color="primary">mdi-plus</v-icon> Pesquisar dotação
							</v-btn>
						</v-col>

						<v-col class="pt-0 pb-0" cols="12" md="1">
							<v-text-field
								v-model="numeroDotacao"
								label="Nr. Despesa"
								type="number"
								autofocus
								:disabled="readOnly"
							/>
						</v-col>
						<v-col class="pt-0 pb-0" cols="12" md="2">
							<v-text-field
								v-model="anoOrcamento"
								label="Ano Orçamento"
								type="number"
								:disabled="readOnly"
							/>
						</v-col>
					</v-row>
				</v-form> -->

				<v-dotacao-list
					v-model="dotacaoList"
					:value="dotacaoList"
					:read-only="readOnly"
					:dotEmenda="true"
					@atualizar="atualizarDot"
				/>

				<v-divider></v-divider>

				<v-row>
					<v-col md="3" offset-md="3">
						<v-text-field
							class="centered-input"
							label="Valor da Emenda"
							:value="valor$"
							placeholder="0"
							filled
							rounded
							dense
							readonly
						/>
					</v-col>
					<v-col md="3">
						<v-text-field
							class="centered-input"
							label="Total Fixado Final"
							:value="totalFixadoFinal$"
							placeholder="0"
							filled
							rounded
							dense
							readonly
						/>
					</v-col>
					<v-col md="3">
						<v-text-field
							:class="[
								'centered-input',
								diferencaDotacao < 0 ? 'verde' : '',
								diferencaDotacao > 0.001 ? 'vermelho' : '',
							]"
							label="Diferença"
							:value="diferencaDotacao$"
							placeholder="0"
							filled
							rounded
							dense
							readonly
						/>
					</v-col>
				</v-row>
			</v-tab-item>

			<v-tab-item value="tabProcessos">
				<!-- <v-form ref="formProcesso" @keyup.native.enter="incluirProcesso">	
					<v-row>

						<v-col class="pt-0 pb-0" cols="12" md="2">
							<v-text-field
								v-model="anoProcesso"
								label="Ano Processo"
								type="number"
								autofocus
								:disabled="readOnly"
							/>
						</v-col>

						<v-col class="pt-0 pb-0" cols="12" md="2">
							<v-text-field
								v-model="nrProcesso"
								label="Nr. Processo"
								type="number"
								:disabled="readOnly"
							/>
						</v-col>

						<v-col class="text-right">
							<v-btn primary @click="incluirProcesso" :disabled="readOnly">
								<v-icon color="primary">mdi-plus</v-icon> Incluir Processo
							</v-btn>
						</v-col>
					</v-row>
				</v-form> -->

				<v-data-table
					v-model="processosSelecionados"
					hide-default-footer
					:headers="headersProcessos"
					:items="processoList"
					class="elevation-1 row-pointer"
					no-data-text="Não há processos cadastrados para a emenda"
					ref="tableProcessos"
					item-key="nrProcessoFormatado"
				>
					<!-- <template v-slot:[`item.actions`]="{ item }" v-if="processoList">
						<v-btn
							color="danger"
							small
							@click="removeProcesso(item)"
						>
						Remover processo
						</v-btn>
					</template> -->
					<!-- <template v-slot:[`item.nrProcessoFormatado`]="props">
						<a target="_blank" :href="`${enderecoConsultaProc}/${props.item.anoProcesso}/${props.item.numeroProcesso.toString().slice(0, -1)}`" v-if="props.item.anoProcesso">
							{{ props.item.nrProcessoFormatado }}
						</a>
					</template> -->
					<template v-slot:[`item.nrProcessoSei`]="props">
						<a
							target="_blank"
							:href="`${props.item.linkPesquisaSei}`"
							v-if="props.item.nrProcessoSei"
						>
							{{ props.item.nrProcessoSei }}
						</a>
					</template>
				</v-data-table>
			</v-tab-item>

			<v-tab-item value="tabCpl">
				<!-- <v-form ref="formCpl" @keyup.native.enter="incluirCpl">	

					<v-row>

						<v-col class="pt-2 pb-0" cols="12" md="2">
							<v-text-field
								v-model="anoCpl"
								label="Ano CPL"
								type="number"
								autofocus
							/>
						</v-col>

						<v-col class="pt-2 pb-0" cols="12" md="2">
							<v-text-field
								v-model="nrCpl"
								label="Nr. CPL"
								type="number"								
							/>
						</v-col>

					</v-row>
				</v-form> -->

				<v-data-table
					v-model="cplsSelecionadas"
					hide-default-footer
					:headers="headersCpls"
					:items="cplList"
					class="elevation-1 row-pointer"
					no-data-text="Não há CPL's cadastradas para a emenda"
					ref="tableCpls"
					item-key="id"
				>
					<template v-slot:[`item.nrProcessoFormatado`]="props">
						<a
							target="_blank"
							:href="`${enderecoConsultaProc}/${
								props.item.anoProcesso
							}/${props.item.numeroProcesso.toString().slice(0, -1)}`"
							v-if="props.item.anoProcesso"
						>
							{{ props.item.nrProcessoFormatado }}
						</a>
					</template>
				</v-data-table>

				<!-- <v-textarea class="pt-12"
					v-model="textoInformacoesCpl"
					rows="8"
					maxlength="8000"
					counter
					required
					auto-grow
					disabled
				></v-textarea> -->

				<br />

				<div>
					Para maiores informações, consulte:
					<a target="_blank" :href="`${textoInformacoesCpl}`">
						{{ textoInformacoesCpl }}
					</a>
				</div>
			</v-tab-item>
		</v-tabs-items>

		<!-- despacho -->
		<v-bottom-sheet persistent width="70%" v-model="solicitarDespacho">
			<v-sheet class="text-center">
				<v-col md="12">
					<v-form v-model="despachoValido" ref="formDespacho">
						<v-textarea
							autofocus
							v-model="despacho"
							label="Favor informar despacho:"
							rows="3"
							filled
							background-color="blue lighten-5"
							auto-grow
							counter
							required
							:rules="[
								$rules.required(),
								$rules.conterEspaco({
									msg: 'O despacho deve conter mais de uma palavra.',
								}),
							]"
							maxlength="1000"
						/>
						<v-select
							v-if="situacaoFluxoDestinoItems"
							v-model="despachoSituacao"
							:rules="[$rules.required()]"
							:items="situacaoFluxoDestinoItems"
							label="Situação da Emenda"
							item-text="emendaSituacaoDestino.descricao"
							item-value="emendaSituacaoDestino.id"
							filled
							background-color="blue lighten-5"
							required
							return-object
						/>
					</v-form>
				</v-col>
				<!-- <v-row>
					<v-col md="12">
						<div class="info-despacho" v-if="situacaoInicial && emendaSituacao">
							O despacho se faz necessário pois a alteração de situação de
							<span class="situacao">{{ situacaoInicial.descricao }}</span> para
							<span class="situacao">{{ emendaSituacao.descricao }}</span> gera
							uma tramitação.
						</div>
					</v-col>
				</v-row> -->

				<v-row>
					<v-col md="12">
						<v-btn
							class="mr-5"
							outlined
							v-shortkey.once="['esc']"
							@shortkey="cancelarTramitacao"
							@click="cancelarTramitacao"
						>
							Cancelar
						</v-btn>
						<v-btn
							outlined
							v-shortkey.once="['ctrl', 'enter']"
							@shortkey="enviarDespacho"
							color="primary"
							@click="enviarDespacho"
						>
							Enviar
						</v-btn>
					</v-col>
				</v-row>
			</v-sheet>
		</v-bottom-sheet>

		<!-- dotação -->
		<v-bottom-sheet persistent width="70%" v-model="solicitarDotacao">
			<v-sheet class="text-center">
				<v-col md="12">
					<v-form v-model="dotacaoValida" ref="formPesquisarDotacao">
						<v-dotacao-list
							v-model="dotacoesSecretaria"
							:read-only="readOnly"
							@clicar="enviarDotacao"
						/>

						<v-row>
							<v-col md="12">
								<v-btn
									class="mr-5"
									outlined
									v-shortkey.once="['esc']"
									@shortkey="cancelarDotacao"
									@click="cancelarDotacao"
								>
									Cancelar
								</v-btn>
								<!-- <v-btn
									outlined
									v-shortkey.once="['ctrl', 'enter']"
									@shortkey="enviarDotacao"
									color="primary"
									@click="enviarDotacao"
								>
									Incluir Selecionadas
								</v-btn> -->
							</v-col>
						</v-row>
					</v-form>
				</v-col>
			</v-sheet>
		</v-bottom-sheet>
	</v-form>
</template>

<script>
import { getYear } from 'date-fns';
import _ from 'lodash';
import VDotacaoList from '@/components/DotacaoList.vue';
import VTramitacaoList from '@/components/TramitacaoList.vue';

export default {
	props: ['value', 'tab', 'readOnly'],
	data() {
		return {
			//número da emenda, situação da emenda, secretaria, número da dotação, justificativa da emenda, instituição de destino, paamentar, e observações
			id: null,
			numeroEmenda: null,
			descricao: null,
			valor: 0,
			esfera: null,
			emendaSituacao: null,
			secretaria: null,
			instituicao: null,
			justificativa: null,
			anoExercicio: null,
			parlamentarExercicio: null,
			observacao: null,
			respostaCamara: null,
			linkRelatorioGestao: null,
			linkPlanoTrabalho: null,

			despacho: null,

			dotacoes: [],
			dotacoesSecretaria: [],

			tramitacoesEmenda: [],

			numeroDotacao: null,
			anoOrcamento: null,

			situacaoItems: [],
			secretariaItems: [],
			esferaItems: [],
			parlamentarItems: [],

			situacaoFluxoDestinoItems: null,

			solicitarDespacho: false,
			solicitarDotacao: false,

			valid: null,
			despachoValido: null,
			dotacaoValida: null,

			intervaloAno: {
				start: 1900,
				end: getYear(new Date()) + 4,
				msg: 'Ano inválido. Deve ser entre ${start} e ${end}',
			},

			situacaoInicial: null,
			despachoSituacao: null,
			pesquisarDotacao: false,

			anoProcesso: null,
			nrProcesso: null,
			nrProcessoFormatado: null,

			processos: [],
			processosSelecionados: [],
			headersProcessos: [
				//{ text: 'Ano Processo', value: 'anoProcesso' },
				//{ text: 'Nr. Processo', value: 'nrProcesso' },
				//{ text: 'Ano / Número Processo', value: 'nrProcessoFormatado', width: 250 },
				{ text: 'Processo Sei', value: 'nrProcessoSei' },
				{
					text: 'Status Atual',
					value: 'statusEmendaAtual.tipoStatusProcesso.descricaoTipoStatus',
				},
				{ text: 'Data Status', value: 'statusEmendaAtual.dataStatus' },
				//{ text: '', value: 'actions', sortable: false }
			],

			enderecoConsultaProc:
				'https://servicos.sorocaba.sp.gov.br/comunique_se/#/processos',

			anoCpl: null,
			nrCpl: null,

			cpls: [],
			cplsSelecionadas: [],
			headersCpls: [
				{
					text: 'Ano / Número Processo',
					value: 'nrProcessoFormatado',
					width: 250,
				},
				{ text: 'Ano CPL', value: 'anoCpl' },
				{ text: 'Nr. CPL', value: 'numeroCpl' },
				{
					text: 'Status Atual',
					value: 'statusEmendaAtual.tipoStatusCpl.descricaoTipoStatus',
				},
				{ text: 'Data Status', value: 'statusEmendaAtual.dataStatus' },
			],

			textoInformacoesCpl: null,
		};
	},
	components: { VDotacaoList, VTramitacaoList },

	computed: {
		parlamentarNaoCarregado() {
			if (!this.anoExercicio) {
				return 'Favor informar ano do exercício antes';
			}

			if (!this.esfera) {
				return 'Favor informar esfera antes';
			}

			return `Parlamentar ${this.esfera.descricao.toLowerCase()} não encontrado para ${
				this.anoExercicio
			} `;
		},

		totalFixadoFinal() {
			if (this.dotacoes && this.dotacoes.length > 0) {
				return this.dotacoes.reduce(
					(a, b) => a + (b.dotacao.valorFixadoFinal || 0),
					0
				);
			} else {
				return 0;
			}
		},

		totalFixadoFinal$() {
			return this.setMascara(this.totalFixadoFinal);
		},
		valor$() {
			return this.setMascara(parseFloat(this.valor));
		},
		diferencaDotacao() {
			return this.valor - this.totalFixadoFinal;
		},
		diferencaDotacao$() {
			return this.setMascara(this.diferencaDotacao);
		},

		dotacaoList() {
			let dotList = [];
			this.dotacoes.forEach((dot) => {
				dotList.push(dot.dotacao);
			});
			return dotList;
		},

		processoList() {
			let procList = [];
			if (this.processos && this.processos.length > 0) {
				this.processos.forEach((proc) => {
					procList.push(proc);
				});
			}
			return procList;
		},

		cplList() {
			let cplList = [];
			if (this.cpls && this.cpls.length > 0) {
				this.cpls.forEach((cpl) => {
					cplList.push(cpl);
				});
			}
			return cplList;
		},
	},
	async created() {
		[this.situacaoItems, this.secretariaItems, this.esferaItems] =
			await this.$fetch.getAll([
				`emendas/situacoes`,
				`emendas/secretarias`,
				`parlamentares/esferas`,
			]);

		await this.pesquisarDotacoesSecretarias();

		await this.pesquisarTexto();

		if (!this.id) {
			this.anoExercicio = this.$root.anoSelecionado;
			this.emendaSituacao = { id: 1 };
		}
	},

	watch: {
		value(emenda) {
			this.id = emenda.id;
			this.numeroEmenda = emenda.numeroEmenda;
			this.descricao = emenda.descricao;
			this.valor = emenda.valor;
			this.esfera = emenda.esfera;
			this.emendaSituacao = emenda.emendaSituacao;
			this.secretaria = emenda.secretaria;
			this.dotacoes = emenda.dotacoesEmenda;
			this.instituicao = emenda.instituicao;
			this.justificativa = emenda.justificativa;
			this.anoExercicio = emenda.anoExercicio;
			this.parlamentarExercicio = emenda.parlamentarExercicio;
			this.observacao = emenda.observacao;
			this.respostaCamara = emenda.respostaCamara;
			this.linkPlanoTrabalho = emenda.linkPlanoTrabalho;
			this.linkRelatorioGestao = emenda.linkRelatorioGestao;
			this.tramitacoesEmenda = emenda.tramitacoesEmenda;
			this.processos = emenda.processosEmenda;
			this.cpls = emenda.cplsEmenda;
		},
		$data: {
			handler() {
				this.atualizarValue();
			},
			deep: true,
		},
		emendaSituacao(situacao) {
			if (this.situacaoInicial === null) {
				this.situacaoInicial = situacao;
			}
			this.fetchSituacoesDestinoItems(this.emendaSituacao.id);
		},
		anoExercicio() {
			this.atualizarParlamentaresDebounced();
		},
		esfera() {
			this.atualizarParlamentaresDebounced();
		},
	},

	methods: {
		async salvar() {
			try {
				this.$emit('salvando', true);
				await this.$refs.form.validate();

				let emendaSalvo;
				if (this.valid) {
					if (this.situacaoInicial && this.emendaSituacao) {
						if (
							this.situacaoInicial.id !== this.emendaSituacao.id &&
							!this.despacho
						) {
							this.solicitarDespacho = true;
							return;
						}
					}
					if (this.id) {
						emendaSalvo = await this.$fetch.put(
							`emendas/${this.id}`,
							this.value
						);
						this.$emit('updated', emendaSalvo, 'update');
					} else {
						emendaSalvo = await this.$fetch.post(`emendas`, this.value);
						await this.pesquisarDotacoesSecretarias();
						this.$emit('saved', emendaSalvo, 'save');
					}
				}
				return emendaSalvo;
			} catch (err) {
				this.$root.dialog = { title: 'Emenda não salva', msg: err.msg };
			} finally {
				this.$emit('salvando', false);
			}
		},

		async remover() {
			try {
				this.$emit('removendo', true);
				let emendaRemovida = await this.$fetch.delete(`emendas/${this.id}`);
				this.$emit('deleted', emendaRemovida);
				this.$emit('removendo', false);
				return emendaRemovida;
			} catch (err) {
				this.$root.dialog = { title: 'Emenda não Removida', msg: err.msg };
			}
		},

		async obterEmenda(id) {
			return this.$fetch.get(`emendas/${id}`);
		},
		limparCampos() {
			this.$refs.form.reset();
		},
		atualizarValue() {
			this.$emit('input', {
				id: this.id,
				numeroEmenda: this.numeroEmenda,
				descricao: this.descricao,
				valor: this.valor,
				esfera: this.esfera,
				emendaSituacao: this.emendaSituacao,
				secretaria: this.secretaria,
				//dotacoes: this.dotacoes,
				dotacoesEmenda: this.dotacoes,
				instituicao: this.instituicao,
				justificativa: this.justificativa,
				anoExercicio: this.anoExercicio,
				parlamentarExercicio: this.parlamentarExercicio,
				observacao: this.observacao,
				linkPlanoTrabalho: this.linkPlanoTrabalho,
				linkRelatorioGestao: this.linkRelatorioGestao,
				respostaCamara: this.respostaCamara,
				despacho: this.despacho,
				tramitacoesEmenda: this.tramitacoesEmenda,
				processosEmenda: this.processos,
				cplsEmenda: this.cpls,
			});
		},

		atualizarParlamentaresDebounced: _.debounce(function () {
			this.atualizarParlamentares();
		}, 300),
		async atualizarParlamentares() {
			let anoExercicio = this.anoExercicio;
			let idEsfera = this.esfera && this.esfera.id;
			if (
				this.$rules.between(this.intervaloAno)(anoExercicio) === true &&
				idEsfera
			) {
				this.parlamentarItems = await this.$fetch.get(`emendas/parlamentares`, {
					anoExercicio,
					idEsfera,
				});

				if (this.parlamentarExercicio.id) {
					let parlamentarSelecionado = await this.$fetch.get(
						`emendas/parlamentares/${this.parlamentarExercicio.id}`
					);
					this.parlamentarItems.splice(0, 0, parlamentarSelecionado);
				}

				if (
					this.parlamentarExercicio &&
					!this.parlamentarItems.some(
						(p) => p.id == this.parlamentarExercicio.id
					)
				) {
					this.parlamentarExercicio = null;
				}
			}
		},

		async incluirDotacao() {
			if (this.anoOrcamento && this.numeroDotacao) {
				try {
					let dotacao = await this.$fetch.get('emendas/dotacao/', {
						anoOrcamento: this.anoOrcamento,
						numeroDotacao: this.numeroDotacao,
						secretariaOrgaoCodigo: this.secretaria.orgaoCodigo,
					});
					//this.dotacoes.push(dotacao);
					this.dotacoes.push({
						idEmenda: this.id,
						idDotacao: dotacao.id,
						dotacao: dotacao,
					});
				} catch (err) {
					this.$root.dialog = { title: 'Dotação não incluída', msg: err.msg };
				}
			} else {
				this.$root.dialog = {
					title: 'Dotação não incluída',
					msg: 'Informe Nr. e Ano do Orçamento',
				};
			}
		},

		async incluirProcesso() {
			if (this.anoProcesso && this.nrProcesso) {
				try {
					let processo = await this.$fetch.get('emendas/processo/', {
						anoProcesso: this.anoProcesso,
						nrProcesso: this.nrProcesso,
					});

					//console.log('a ',this.processos);

					if (typeof this.processos === 'undefined') {
						this.processos = [];
					}
					this.processos.push({
						idEmenda: this.id,
						anoProcesso: processo.ano,
						numeroProcesso: processo.numero,
						nrProcessoFormatado: processo.numeroProcessoFormatado,
					});

					this.anoProcesso = '';
					this.nrProcesso = '';

					//console.log('b ', this.processos);
				} catch (err) {
					this.$root.dialog = { title: 'Processo não incluído', msg: err.msg };
				}
			} else {
				this.$root.dialog = {
					title: 'Processo não incluída',
					msg: 'Informe Nr. e Ano do Processo',
				};
			}
		},

		setMascara(v) {
			return v.toLocaleString('pt-BR', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
				style: 'currency',
				currency: 'BRL',
			});
		},

		async enviarDespacho() {
			try {
				await this.$refs.formDespacho.validate();

				if (this.despachoValido) {
					let emendasTramitar = [this.id];

					let tramitacao = {
						despacho: this.despacho,
						emendasTramitar,
						situacao: this.despachoSituacao,
					};

					this.solicitarDespacho = false;

					//await this.salvar();
					await this.$fetch.post(`emendas/tramitar`, tramitacao);

					this.$emit('atualizar');

					await this.$emit('snack', {
						show: true,
						text: `Emenda tramitada com sucesso para "${this.despachoSituacao.emendaSituacaoDestino.descricao}"`,
					});

					await this.resetTramitacao();

					//this.$router.replace('/emendas');
				}
			} catch (err) {
				this.$root.dialog = { title: 'Tramitação não realizada', msg: err.msg };
			}
		},

		async enviarDotacao(dotacoesSelecionadas) {
			// for (var i=0; i < dotacoesSelecionadas.length; i++){
			// 	this.dotacoes.push(dotacoesSelecionadas[i]);
			// }

			if (
				this.dotacoes.filter((d) => d.id == dotacoesSelecionadas.id).length == 0
			) {
				this.dotacoes.push({
					idEmenda: this.id,
					idDotacao: dotacoesSelecionadas.id,
					dotacao: dotacoesSelecionadas,
				});
				//this.dotacoes.push(dotacoesSelecionadas);
			}

			this.solicitarDotacao = false;
		},

		async cancelarTramitacao() {
			this.$emit('salvando', false);
			await this.resetTramitacao();
			this.solicitarDespacho = false;
		},

		async resetTramitacao() {
			this.despacho = null;
			this.despachoSituacao = null;
			await this.$refs.formDespacho.reset();
		},

		exibirTramitar() {
			this.solicitarDespacho = true;
		},

		exibirPesquisaDotacao() {
			this.solicitarDotacao = true;
		},

		cancelarDotacao() {
			this.solicitarDotacao = false;
		},

		async fetchSituacoesDestinoItems(idFluxoOrigem) {
			try {
				this.situacaoFluxoDestinoItems = await this.$fetch.get(
					'emendas/situacoesFluxoDestino',
					{
						idFluxoOrigem,
					}
				);
			} catch (err) {
				this.$root.dialog = {
					title: 'Não foi possível carregar situações',
					msg: err.msg,
				};
			}
		},

		async pesquisarDotacoesSecretarias() {
			// pesquisar as dotações da secretaria
			try {
				this.dotacoesSecretaria = await this.$fetch.get(
					'emendas/dotacoesSecretaria/',
					{
						secretariaOrgaoCodigo: this.secretaria.orgaoCodigo,
					}
				);
				this.dotacoesSecretaria = this.dotacoesSecretaria.filter(
					(d) => d.anoOrcamento == this.anoExercicio
				);
			} catch {
				this.dotacoesSecretaria = [];
			}
		},

		atualizarDot(dot) {
			this.dotacoes = this.dotacoes.filter((d) => d.dotacao.id !== dot.id);
		},

		removeProcesso(item) {
			this.processos = this.processos.filter((d) => d !== item);
			//this.$emit('input', this.processos);
		},

		async pesquisarTexto() {
			const textos = await this.$fetch.get(`emendas/informacoesCpl`);

			if ((textos !== null) && (textos.textoInformacoesCpl !== null)) {
				this.textoInformacoesCpl = textos.textoInformacoesCpl;
			}
		},
	},
};
</script>

<style scoped>
.centered-input >>> input {
	text-align: center;
}
.centered-input >>> label {
	right: -50% !important;
	text-align: center !important;
}
.vermelho >>> .v-input__slot {
	background-color: #ff9595 !important;
}
.verde >>> .v-input__slot {
	background-color: #95ff9d !important;
}
.situacao {
	font-weight: bold;
	color: orangered;
}
.info-despacho {
	text-align: center;
	font-size: 80%;
}

form >>> * {
	color: rgba(0, 0, 0, 0.87) !important;
}

.no-button >>> .v-input__append-inner {
	/* para desabilitar o botão do select */
	visibility: hidden !important;
}
</style>
